namespace HA.Core.Repository {
    export class Data extends Repository {


        public saveForm(d: Map<string, any> | FormData) {
            return this.request(toMap({
                data: d,
                url: "/ha/form",
            }));
        }

        public fetchData(d: Map<string, any> | FormData) {
            return this.request(toMap({
                data: d,
                url: "/ha/app",
            }));
        }

        public saveData(d: Map<string, any> | FormData) {
            return this.request(toMap({
                data: d,
                url: "/ha/app",
            }));
        }

        public saveLocation() {
            const me = this;
            this.requestGet(toMap({url: "https://ipinfo.io/json"})).then(
            (response: Map<any, any>) => {
                response.set("id", "geoip");
                me.saveData(response);
            });
        }

    }
}
